import React from "react";
import { styled } from "@mui/system";
import Profile from "../assets/female-developer-vector-removebg-preview.png";
import BadgeIcon from "@mui/icons-material/Badge";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";


const Container = styled("section")({
  display: "flex",
  flexDirection: "column",
});

const InfoContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: "30px",
});

const Subtitle5 = styled("h5")({
  fontSize: "12px",
  fontWeight: "500",
  color: "var(--color-light)",
});

const Subtitle3 = styled("h3")({
  fontSize: "18px",
  fontWeight: "500",
});

const Title = styled("h1")({
  fontSize: "30px",
  color: "var(--color-primary)",
});

const Wrapper = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  "@media (max-width: 1020px)": {
    flexDirection: "column",
    alignItems: "center",
  },
});

const Left = styled("div")({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const ImageContainer = styled("div")({
  width: "50%",
  height: "70%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "var(--color-bg-variant)",
  padding: "5px",
  borderRadius: "10px",
  boxShadow: "1px 1px 4px 4px var(--color-bg)",
});


const Image = styled("img")({
  width: "95%",
  height: "95%",
  objectFit: "contain",
  background: "linear-gradient(var(--color-primary), #4db5ff50)",
  overflow: "hidden",
  padding: "5px 5px 5px 5px",
  transform: "rotate(10deg)",
  borderRadius: "10px",
  boxShadow: "1px 1px 4px 4px var(--color-bg)",
  transition: "all 1s ease",
  "&:hover": {
    transform: "rotate(0deg)",
  },
});

const Right = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  // alignItems: 'center',
  justifyContent: "center",
  "@media (max-width: 1020px)": {
    width: "80%",
    marginTop: "20px",
  },
});

const Cards = styled("div")({
  display: "flex",
  justifyContent: "center",
  "@media (max-width: 1020px)": {
    flexDirection: "column",
  },
});

const Card = styled("span")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  margin: "20px",
  borderRadius: "10px",
  backgroundColor: "var(--color-bg-variant)",
  gap: "20px",
  minWidth: "25%",
  transition: "all 1s ease",
  "&:hover": {
    backgroundColor: "#1f1f38",
    border: "1px solid var(--color-primary)",
    transform: "scale(1.1)",
  },
});

const CardDescription = styled("span")({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
});

const Content = styled("span")({
  display: "block",
  textAlign: "justify",
  lineHeight: "1.3",
  padding: "20px",
  marginTop: "20px",
});

const Button = styled("a")({
  backgroundColor: "var(--color-primary)",
  color: "var(--color-bg)",
  width: "fit-content",
  fontWeight: "600",
  cursor: "pointer",
  borderRadius: "5%",
  border: "1px solid var(--color-primary)",
  padding: "10px",
  marginLeft: "20px",
  transition: "all 0.5s ease",
  boxShadow: "2px 2px 4px 4px var(--color-bg)",
  "&:hover": {
    color: "var(--color-bg)",
    backgroundColor: "var(--color-white)",
    borderColor: "transparent",
    transform: "scale(1.05)",
  },
});

function About() {
  return (
    <Container id="about">
      <InfoContainer>
        <Subtitle5>Get to know</Subtitle5>
        <Title>About me</Title>
      </InfoContainer>
      <Wrapper>
        <Left>
          <ImageContainer>
            <Image src={Profile} alt="This is me"></Image>
          </ImageContainer>
        </Left>
        <Right>
          <Cards>
            <Card>
              <BadgeIcon style={{ color: "var(--color-primary)" }}></BadgeIcon>
              <CardDescription>
                <Subtitle3>Experience</Subtitle3>
                <Subtitle5>+3 Years Working</Subtitle5>
              </CardDescription>
            </Card>
            <Card>
              <FolderCopyIcon
                style={{ color: "var(--color-primary)" }}
              ></FolderCopyIcon>
              <CardDescription>
                <Subtitle3>Projects</Subtitle3>
                <Subtitle5>+10 Completed</Subtitle5>
              </CardDescription>
            </Card>
          </Cards>
          <Content>
            <p>
              Passionate software engineer and full-stack developer with a
              strong expertise in web development, software engineering, data
              analysis, and artificial intelligence . Over the past years, I
              have transformed complex ideas into innovative digital solutions,
              building everything from interactive websites and e-commerce
              platforms to custom software and intelligent AI-driven systems.
            </p>
            <p>
              With every project, I aim to combine creativity, precision, and
              innovation, helping my clients grow and succeed in the digital
              world. Let’s build something extraordinary together!
            </p>
            <br/>
            <em>“Turning Ideas Into Impact Through Smart Websites and Intelligent Solutions.”</em>
          </Content>
          <Button href="#contact">Let's Connect</Button>
        </Right>
      </Wrapper>
    </Container>
  );
}

export default About;
